import { keyBy } from "lodash";

import { CRUDAction, IEntityFetchCollectionSuccess, RequestAction } from "store/entities/actions";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IEntityCollectionState } from "store/entities/reducer";

import { TAG, TagAction, TagActionNames } from "./actions";
import { ICreateTagSuccessPayload, IDeleteTagSuccessPayload, IFetchSingleSuccessPayload, ITag } from "./interfaces";

const initialState = {};

export const tagsReducer = (
  state: IEntityCollectionState<ITag> = initialState,
  action: TagAction
): IEntityCollectionState<ITag> => {
  switch (action.type) {
    case TAG[CRUDAction.FETCH_SINGLE][RequestAction.SUCCESS]: {
      const { value: tag } = action.payload as IFetchSingleSuccessPayload;
      return {
        ...state,
        [tag.id]: tag,
      };
    }

    case TAG[CRUDAction.FETCH_COLLECTION][RequestAction.SUCCESS]: {
      const { values } = action.payload as IEntityFetchCollectionSuccess<ITag>;
      return keyBy(values, v => v.id);
    }

    case TAG[CRUDAction.CREATE][RequestAction.SUCCESS]:
    case TAG[CRUDAction.UPDATE][RequestAction.SUCCESS]: {
      const { value: tag } = action.payload as ICreateTagSuccessPayload;
      return {
        ...state,
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        [tag.id]: {
          // @ts-expect-error TS(2532): Object is possibly 'undefined'.
          ...state[tag.id],
          ...tag,
        },
      };
    }

    case TAG[CRUDAction.DELETE][RequestAction.SUCCESS]:
    case TagActionNames.SYNC_DELETE: {
      const { id } = action.payload as IDeleteTagSuccessPayload;
      const newState = { ...state };
      // @ts-expect-error TS(2538): Type 'undefined' cannot be used as an index type.
      delete newState[id];
      return newState;
    }

    default:
      return state;
  }
};
